// @ts-nocheck
import {
  ADD_NEW_CHAT_ROOM_GROUP_CHAT_FAILURE,
  ADD_NEW_CHAT_ROOM_GROUP_CHAT_LOADING,
  ADD_NEW_CHAT_ROOM_GROUP_CHAT_SUCCESS,
  ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT,
  ADDED_TO_GROUP_CHAT,
  CREATE_NEW_POST_FAILURE,
  CREATE_NEW_POST_LOADING,
  CREATE_NEW_POST_SUCCESS,
  EDIT_NEW_MESSAGE_GROUP_CHAT_FAILURE,
  EDIT_NEW_MESSAGE_GROUP_CHAT_LOADING,
  EDIT_NEW_MESSAGE_GROUP_CHAT_SUCCESS,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS,
  GET_MESSAGE_PARTICIPANT_STATUS_FAILURE,
  GET_MESSAGE_PARTICIPANT_STATUS_REQUEST,
  GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS,
  GET_UNREAD_MESSAGES_FAILURE,
  GET_UNREAD_MESSAGES_REQUEST,
  GET_UNREAD_MESSAGES_SUCCESS,
  GROUP_CHAT_ROOMS_FAILURE,
  GROUP_CHAT_ROOMS_LOADING,
  GROUP_CHAT_ROOMS_SUCCESS,
  ON_DELETE_MESSAGE_GROUP_CHAT,
  ON_EDIT_MESSAGE_GROUP_CHAT,
  ON_MARK_MESSAGES_AS_READ_GROUP_CHAT,
  ON_NEW_MESSAGE_GROUP_CHAT,
  ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT,
  REMOVED_FROM_GROUP_CHAT,
  RESET_GROUP_CHAT_SLICE,
  SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT,
  SEND_NEW_MESSAGE_LOADING_GROUP_CHAT,
  SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT,
  SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE,
  SET_UNREAD_CHAT_ROOMS_COUNT_LOADING,
  SET_UNREAD_GROUP_CHAT_ROOMS_COUNT,
  TOP_N_EVENTS_FAILURE,
  TOP_N_EVENTS_LOADING,
  TOP_N_EVENTS_SUCCESS,
  UPDATE_GROUP_CHAT,
  UPDATE_GROUP_CHAT_STATUS_FAILURE,
  UPDATE_GROUP_CHAT_STATUS_LOADING,
  UPDATE_GROUP_CHAT_STATUS_SUCCESS,
  UPDATE_POST_COLLAPSE_MESSAGES,
} from "../constants/groupMessaging";
import {
  SETUP_LOADING,
  SETUP_SUCCESS,
  SETUP_FAILURE,
  MESSAGE_CONTAINER_SCROLL,
} from "../constants/oneononemessaging";

// handlers start...
const getChatRoomMessagesData = (
  state,
  chatRoomMessagesActionPayload,
  chatRoomPosts,
) => {
  if (
    chatRoomMessagesActionPayload?.[0]?.chatId ===
    state?.selectedChatRoom?.data?._id
  ) {
    for (let i = 0; i < chatRoomMessagesActionPayload?.length; i++) {
      const postIndex = chatRoomPosts?.findIndex((chatRoom) => {
        return (
          chatRoom?.postMetaData?.postId ===
          chatRoomMessagesActionPayload?.[i]?.postId
        );
      });

      if (postIndex >= 0) {
        chatRoomPosts[postIndex]?.messages?.push?.(
          chatRoomMessagesActionPayload?.[i],
        );
        if (chatRoomMessagesActionPayload?.[i]?.parentId) {
          chatRoomPosts[postIndex].postMetaData.parentId =
            chatRoomMessagesActionPayload?.[i]?.parentId;
        }
      } else {
        chatRoomPosts.push({
          postMetaData: {
            postId: chatRoomMessagesActionPayload?.[i]?.postId,
            parentId: chatRoomMessagesActionPayload?.[i]?.parentId || "",
            collapsedMessages: true,
          },
          messages: [chatRoomMessagesActionPayload?.[i]],
        });
      }
    }
  }

  return chatRoomPosts;
};
// handlers end...

const initialState = {
  topNEvents: {
    data: [],
    isLoading: false,
  },
  messagingContainerScroll: {
    update: 0,
  },
  setup: {
    isLoading: false,
    success: false,
    failure: false,
  },
  chatRooms: {
    data: [],
    isLoading: false,
  },
  selectedChatRoom: {
    data: null,
  },
  chatRoomMessages: {
    data: [],
    chatId: "",
    isLoading: false,
  },
  unreadChatRoomsCount: {
    data: {
      groupCount: null,
    },
    isLoading: false,
  },
  newChatRoom: {
    isLoading: false,
  },
  newPost: {
    isLoading: false,
  },
  newMessage: {
    isLoading: false,
    postId: "",
  },
  updateChatStatus: {
    isLoading: false,
  },
  editMessage: {
    isLoading: false,
  },
  unreadMessages: {
    data: null,
    isLoading: false,
  },

  messageDetails: {
    data: null,
    isLoading: false,
  },
};

const groupMessagingReducer = (state = initialState, action) => {
  switch (action?.type) {
    case MESSAGE_CONTAINER_SCROLL: {
      return {
        ...state,
        messagingContainerScroll: {
          ...state?.messagingContainerScroll,
          update: (state?.messagingContainerScroll?.update + 1) % 10,
        },
      };
    }

    case SETUP_LOADING: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: false,
          failure: false,
          isLoading: true,
        },
      };
    }

    case SETUP_SUCCESS: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: true,
          failure: false,
          isLoading: false,
        },
      };
    }

    case SETUP_FAILURE: {
      return {
        ...state,
        setup: {
          ...state.setup,
          success: false,
          failure: true,
          isLoading: false,
        },
      };
    }

    case TOP_N_EVENTS_LOADING: {
      return {
        ...state,
        topNEvents: {
          ...state?.topNEvents,
          isLoading: true,
        },
      };
    }

    case TOP_N_EVENTS_SUCCESS: {
      return {
        ...state,
        topNEvents: {
          ...state?.topNEvents,
          data: action?.payload?.events || state?.topNEvents?.data,
          isLoading: false,
        },
      };
    }

    case TOP_N_EVENTS_FAILURE: {
      return {
        ...state,
        topNEvents: {
          ...state?.topNEvents,
          isLoading: false,
        },
      };
    }

    case SET_UNREAD_CHAT_ROOMS_COUNT_LOADING: {
      return {
        ...state,
        unreadChatRoomsCount: {
          ...state.unreadChatRoomsCount,
          isLoading: true,
        },
      };
    }

    case SET_UNREAD_GROUP_CHAT_ROOMS_COUNT: {
      return {
        ...state,
        unreadChatRoomsCount: {
          ...state.unreadChatRoomsCount,
          data: {
            ...state.unreadChatRoomsCount.data,
            groupCount: action?.payload?.groupCount,
            oneOnOneCount: action?.payload?.oneOnOneCount,
          },
        },
      };
    }

    case SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE: {
      return {
        ...state,
        unreadChatRoomsCount: {
          ...state.unreadChatRoomsCount,
          isLoading: false,
        },
      };
    }

    case GROUP_CHAT_ROOMS_LOADING:
      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          isLoading: true,
        },
      };

    case GROUP_CHAT_ROOMS_SUCCESS:
      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: action?.payload?.chatRooms,
          isLoading: false,
        },
      };

    case GROUP_CHAT_ROOMS_FAILURE:
      return {
        ...state,
        chatRooms: {
          ...initialState?.chatRooms,
          isLoading: false,
        },
      };

    case FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING:
      return {
        ...state,
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          isLoading: true,
        },
      };

    case FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS: {
      const chatRoomPosts = getChatRoomMessagesData(
        state,
        action?.payload?.chatRoomMessages,
        [...(state?.chatRoomMessages?.data || [])],
      );
      // const chatRoomPosts = [...(state?.chatRoomMessages?.data || [])];

      // if (action?.payload?.chatRoomMessages?.[0]?.chatId === state?.selectedChatRoom?.data?._id) {
      //   for (let i = 0; i < action?.payload?.chatRoomMessages?.length; i++) {
      //     const postIndex = chatRoomPosts?.findIndex(chatRoom => {
      //       return (chatRoom?.postMetaData?.postId === action?.payload?.chatRoomMessages?.[i]?.postId);
      //     });

      //     if (postIndex >= 0) {
      //       chatRoomPosts[postIndex]?.messages?.push?.(action?.payload?.chatRoomMessages?.[i]);
      //       if (action?.payload?.chatRoomMessages?.[i]?.parentId) {
      //         chatRoomPosts[postIndex].postMetaData.parentId = action?.payload?.chatRoomMessages?.[i]?.parentId;
      //       }
      //     } else {
      //       chatRoomPosts.push({
      //         postMetaData: {
      //           postId: action?.payload?.chatRoomMessages?.[i]?.postId,
      //           parentId: action?.payload?.chatRoomMessages?.[i]?.parentId || "",
      //           collapsedMessages: true
      //         },
      //         messages: [action?.payload?.chatRoomMessages?.[i]]
      //       })
      //     }
      //   }
      // }

      return {
        ...state,
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: chatRoomPosts,
          chatId:
            action?.payload?.chatRoomMessages?.[0]?.chatId ||
            state?.chatRoomMessages?.chatId,
          isLoading: false,
        },
      };
    }

    case FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE:
      return {
        ...state,
        chatRoomMessages: {
          ...initialState?.chatRoomMessages,
        },
      };

    case ON_MARK_MESSAGES_AS_READ_GROUP_CHAT: {
      let updatedChatRoomMessages = [...state.chatRoomMessages.data];
      let updatedChatRooms = [...state.chatRooms.data];
      let unreadMsgChatRoomsCount = {
        groupCount: 0,
      };

      if (
        action?.payload?.chatRoomMessages?.[0]?.chatId !==
        state?.chatRoomMessages?.chatId
      ) {
        for (let i = 0; i < action?.payload?.chatRoomMessages?.length; i++) {
          updatedChatRoomMessages = state?.chatRoomMessages?.data?.map(
            (message) => {
              if (
                action?.payload?.chatRoomMessages?.[i]?._id === message?._id
              ) {
                return action?.payload?.chatRoomMessages?.[i];
              } else {
                return message;
              }
            },
          );
        }
      }

      updatedChatRooms = updatedChatRooms?.map((chatRoom) => {
        if (action?.payload?.chatRoomMessages?.[0]?.chatId === chatRoom?._id) {
          return {
            ...chatRoom,
            participants: chatRoom?.participants?.map?.((participant) => {
              if (participant?.userId === action?.payload?.auth?.userId) {
                return {
                  ...participant,
                  unreadMsgCount: 0,
                };
              } else {
                return participant;
              }
            }),
          };
        } else {
          for (let i = 0; i < chatRoom?.participants?.length; i++) {
            if (
              chatRoom?.participants?.[i]?.userId ===
                action?.payload?.auth?.userId &&
              chatRoom?.participants?.[i]?.unreadMsgCount > 0
            ) {
              unreadMsgChatRoomsCount.groupCount += 1;
              break;
            }
          }
          return chatRoom;
        }
      });

      return {
        ...state,
        chatRooms: {
          ...state.chatRooms,
          data: updatedChatRooms,
        },
        chatRoomMessages: {
          ...state.chatRoomMessages,
          data: updatedChatRoomMessages,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            updatedChatRooms?.find((chatRoom) => {
              return chatRoom?._id === state?.selectedChatRoom?.data?._id;
            }) || state?.selectedChatRoom?.data,
        },
        unreadChatRoomsCount: {
          ...state?.unreadChatRoomsCount,
          data: {
            ...state.unreadChatRoomsCount?.data,
            ...unreadMsgChatRoomsCount,
          },
        },
      };
    }

    case ADD_NEW_CHAT_ROOM_GROUP_CHAT_LOADING: {
      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: true,
        },
      };
    }

    case ADD_NEW_CHAT_ROOM_GROUP_CHAT_SUCCESS: {
      const doesChatRoomExist = state?.chatRooms?.data?.find((chatRoom) => {
        return chatRoom?._id === action?.payload?.newChatRoom?._id;
      });

      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: false,
        },
        chatRooms: {
          ...state?.chatRooms,
          isLoading: false,
          data: !doesChatRoomExist
            ? [action?.payload?.newChatRoom, ...(state?.chatRooms?.data || [])]
            : state?.chatRooms?.data,
        },
      };
    }

    case ADD_NEW_CHAT_ROOM_GROUP_CHAT_FAILURE: {
      return {
        ...state,
        newChatRoom: {
          ...state?.newChatRoom,
          isLoading: false,
        },
      };
    }

    case ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT: {
      const doesChatRoomExist = state?.chatRooms?.data?.find((chatRoom) => {
        return chatRoom?._id === action?.payload?.newChatRoom?._id;
      });

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: !doesChatRoomExist
            ? [action?.payload?.newChatRoom, ...(state?.chatRooms?.data || [])]
            : state?.chatRooms?.data,
        },
      };
    }

    case UPDATE_GROUP_CHAT: {
      let updatedChatRoom;
      let isOfSelectedChatRoom = false;

      const updatedChatRooms = state?.chatRooms?.data?.map((chatRoom) => {
        if (chatRoom?._id === action?.payload?.chatRoom?._id) {
          if (chatRoom?._id === state?.selectedChatRoom?.data?._id) {
            isOfSelectedChatRoom = true;
          }
          updatedChatRoom = {
            ...chatRoom,
            ...action?.payload?.chatRoom,
          };
          return {
            ...chatRoom,
            ...action?.payload?.chatRoom,
          };
        } else {
          return chatRoom;
        }
      });

      return {
        ...state,
        chatRooms: {
          ...state.chatRooms,
          data: updatedChatRooms,
        },
        selectedChatRoom: {
          ...state.selectedChatRoom,
          data: isOfSelectedChatRoom
            ? updatedChatRoom
            : state?.selectedChatRoom?.data,
        },
      };
    }

    case UPDATE_GROUP_CHAT_STATUS_LOADING: {
      return {
        ...state,
        updateChatStatus: {
          ...state?.updateChatStatus,
          isLoading: true,
        },
      };
    }

    case UPDATE_GROUP_CHAT_STATUS_SUCCESS: {
      let selectedChatRoom;
      const updatedChatRooms = [...(state?.chatRooms?.data || [])]?.map(
        (chatRoom) => {
          if (chatRoom?._id === action?.payload?.updatedChatRoom?._id) {
            if (chatRoom?._id === state?.selectedChatRoom?.data?._id) {
              selectedChatRoom = {
                ...chatRoom,
                ...(action?.payload?.updatedChatRoom || {}),
              };
            }
            return {
              ...chatRoom,
              ...(action?.payload?.updatedChatRoom || {}),
            };
          } else {
            return chatRoom;
          }
        },
      );

      return {
        ...state,
        updateChatStatus: {
          ...state?.updateChatStatus,
          isLoading: false,
        },
        chatRooms: {
          ...state?.chatRooms,
          data: updatedChatRooms,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data: selectedChatRoom || state?.selectedChatRoom?.data,
        },
      };
    }

    case UPDATE_GROUP_CHAT_STATUS_FAILURE: {
      return {
        ...state,
        updateChatStatus: {
          ...state?.updateChatStatus,
          isLoading: false,
        },
      };
    }

    case ADDED_TO_GROUP_CHAT: {
      let doesChatRoomExist = false;
      let updatedChatRooms = [...state?.chatRooms?.data];

      updatedChatRooms = updatedChatRooms?.map((chatRoom) => {
        if (chatRoom?._id === action?.payload?.chatRoom?._id) {
          doesChatRoomExist = true;
          return { ...action?.payload?.chatRoom };
        } else {
          return chatRoom;
        }
      });

      if (!doesChatRoomExist) {
        updatedChatRooms = [
          ...updatedChatRooms,
          action?.payload?.chatRoom || {},
        ];
      }

      const chatRoomPosts = getChatRoomMessagesData(
        state,
        action?.payload?.chatRoomMessages,
        [],
      );

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: updatedChatRooms,
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: [...chatRoomPosts],
          chatId:
            action?.payload?.chatRoomMessages?.[0]?.chatId ||
            state?.chatRoomMessages?.chatId,
          isLoading: false,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            state?.selectedChatRoom?.data?._id === action?.payload?.chatId
              ? action?.payload?.chatRoom
              : state?.selectedChatRoom?.data,
        },
      };
    }

    case REMOVED_FROM_GROUP_CHAT: {
      let isActiveChatRoom = false;

      if (state?.chatRoomMessages?.chatId === action?.payload?.chatId) {
        isActiveChatRoom = true;
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: state?.chatRooms?.data?.map((chatRoom) => {
            if (chatRoom?._id === action?.payload?.chatId) {
              return action?.payload?.chatRoom;
            } else {
              return chatRoom;
            }
          }),
        },
        // chatRoomMessages: isActiveChatRoom ? {
        //   ...initialState?.chatRoomMessages
        // } : state?.chatRoomMessages,
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            state?.selectedChatRoom?.data?._id === action?.payload?.chatId
              ? action?.payload?.chatRoom
              : state?.selectedChatRoom?.data,
        },
      };
    }

    case CREATE_NEW_POST_LOADING: {
      return {
        ...state,
        newPost: {
          ...state.newPost,
          isLoading: true,
        },
      };
    }

    case CREATE_NEW_POST_SUCCESS: {
      return {
        ...state,
        newPost: {
          ...state.newPost,
          isLoading: false,
        },
      };
    }

    case CREATE_NEW_POST_FAILURE: {
      return {
        ...state,
        newPost: {
          ...state.newPost,
          isLoading: false,
        },
      };
    }

    case SEND_NEW_MESSAGE_LOADING_GROUP_CHAT:
      return {
        ...state,
        newMessage: {
          ...state?.newMessage,
          isLoading: true,
          postId: action?.payload?.postId,
        },
      };

    case SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT:
      return {
        ...state,
        newMessage: {
          ...initialState?.newMessage,
        },
      };

    case SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT:
      return {
        ...state,
        newMessage: {
          ...initialState?.newMessage,
        },
      };

    case EDIT_NEW_MESSAGE_GROUP_CHAT_LOADING:
      return {
        ...state,
        editMessage: {
          ...state?.editMessage,
          isLoading: true,
        },
      };

    case EDIT_NEW_MESSAGE_GROUP_CHAT_SUCCESS:
      return {
        ...state,
        editMessage: {
          ...state?.editMessage,
          isLoading: false,
        },
      };

    case EDIT_NEW_MESSAGE_GROUP_CHAT_FAILURE:
      return {
        ...state,
        editMessage: {
          ...initialState?.editMessage,
        },
      };

    case ON_NEW_MESSAGE_GROUP_CHAT: {
      let isNewMessageOfExistingPost = false;
      let isNewMessageOfActiveChatRoom = false;
      let chatRoomPosts = [...(state.chatRoomMessages.data || [])];
      let chatRoomsData = [];
      let unreadMsgChatRoomsCount = {
        groupCount: 0,
      };

      if (
        state?.selectedChatRoom?.data?._id ===
        action?.payload?.newMessage?.chatId
      ) {
        isNewMessageOfActiveChatRoom = true;
      }

      if (
        action?.payload?.newMessage?.chatId === state?.chatRoomMessages?.chatId
      ) {
        chatRoomPosts = state?.chatRoomMessages?.data?.map((post) => {
          if (
            post?.postMetaData?.postId === action?.payload?.newMessage?.postId
          ) {
            isNewMessageOfExistingPost = true;
            return {
              ...post,
              messages: [
                ...(post?.messages || []),
                action?.payload?.newMessage,
              ],
            };
          } else {
            return post;
          }
        });

        if (!isNewMessageOfExistingPost) {
          chatRoomPosts = [
            ...(state?.chatRoomMessages?.data || []),
            {
              postMetaData: {
                postId: action?.payload?.newMessage?.postId,
                parentId: action?.payload?.newMessage?.parentId || "",
                collapsedMessages: true,
              },
              messages: [action?.payload?.newMessage],
            },
          ];
        }
      }

      chatRoomsData = [...(state.chatRooms?.data || [])]?.map((chatRoom) => {
        if (chatRoom?._id === action?.payload?.newMessage?.chatId) {
          const postIdx = chatRoom?.postDetails?.findIndex?.((post) => {
            return post?.postId === action?.payload?.newMessage?.postId;
          });

          if (postIdx >= 0) {
            return chatRoom;
          } else {
            return {
              ...chatRoom,
              postDetails: [
                ...(chatRoom?.postDetails || []),
                {
                  postId: action?.payload?.newMessage?.postId,
                  postDetails: action?.payload?.newMessage?.postDetails,
                },
              ],
            };
          }
        } else {
          return chatRoom;
        }
      });

      const newMessageChatRoom = chatRoomsData?.find((chatRoom) => {
        return chatRoom?._id === action?.payload?.newMessage?.chatId;
      });

      const newMessageChatRoomIdx = chatRoomsData?.findIndex((chatRoom) => {
        return chatRoom?._id === action?.payload?.newMessage?.chatId;
      });

      for (let i = newMessageChatRoomIdx - 1; i >= 0; i--) {
        chatRoomsData[i + 1] = chatRoomsData[i];
      }

      if (newMessageChatRoomIdx >= 0) {
        chatRoomsData[0] = {
          ...newMessageChatRoom,
          latestMessage: action?.payload?.newMessage?.content,
        };

        if (!isNewMessageOfActiveChatRoom) {
          chatRoomsData = chatRoomsData?.map((chatRoom) => {
            if (chatRoom?._id === action?.payload?.newMessage?.chatId) {
              return {
                ...chatRoom,
                participants: chatRoom?.participants?.map?.((participant) => {
                  if (participant?.userId === action?.payload?.auth?.userId) {
                    return {
                      ...participant,
                      unreadMsgCount: participant?.unreadMsgCount
                        ? participant?.unreadMsgCount + 1
                        : 1,
                    };
                  } else {
                    return participant;
                  }
                }),
              };
            } else {
              return chatRoom;
            }
          });
        }
      }

      for (let i = 0; i < chatRoomsData?.length; i++) {
        for (let j = 0; j < chatRoomsData?.[i]?.participants?.length; j++) {
          if (
            chatRoomsData?.[i]?.participants?.[j]?.userId ===
              action?.payload?.auth?.userId &&
            chatRoomsData?.[i]?.participants?.[j]?.unreadMsgCount > 0
          ) {
            unreadMsgChatRoomsCount.groupCount += 1;
          }
        }
      }

      return {
        ...state,
        chatRooms: {
          ...state.chatRooms,
          data: chatRoomsData,
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: chatRoomPosts,
          isLoading: false,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            chatRoomsData?.find((chatRoom) => {
              return chatRoom?._id === state?.selectedChatRoom?.data?._id;
            }) || state?.selectedChatRoom?.data,
        },
        unreadChatRoomsCount: {
          ...state?.unreadChatRoomsCount,
          data: {
            ...state?.unreadChatRoomsCount?.data,
            ...unreadMsgChatRoomsCount,
          },
        },
      };
    }

    case ON_EDIT_MESSAGE_GROUP_CHAT: {
      let chatRoomsArrCpy = [...state.chatRooms.data];
      let filteredChatRoomMessages = [];

      if (
        action?.payload?.editedMessage?.chatId !==
        (state?.chatRoomMessages?.data?.[0]?.chatId ||
          state?.chatRoomMessages?.chatId)
      ) {
        filteredChatRoomMessages = [...(state?.chatRoomMessages?.data || [])];
      } else {
        filteredChatRoomMessages = state?.chatRoomMessages?.data?.map(
          (chatRoomMessage) => {
            if (chatRoomMessage?._id === action?.payload?.editedMessage?._id) {
              return {
                ...action?.payload?.editedMessage,
              };
            } else {
              return chatRoomMessage;
            }
          },
        );
      }

      chatRoomsArrCpy = chatRoomsArrCpy?.map((chatRoom, chatRoomIdx) => {
        if (
          chatRoom?._id === action?.payload?.editedMessage?.chatId &&
          chatRoom?.latestMessage?._id === action?.payload?.editedMessage?._id
        ) {
          return {
            ...chatRoom,
            latestMessage: action?.payload?.editedMessage,
          };
        } else {
          return chatRoom;
        }
      });

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: chatRoomsArrCpy,
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          // data: action?.payload?.editedMessage?.chatId !== state?.chatRoomMessages?.data?.[0]?.chatId ? (
          //   [...(state?.chatRoomMessages?.data || [])]
          // ) : state?.chatRoomMessages?.data?.filter(chatRoomMessage => {
          //   return (chatRoomMessage?._id !== action?.payload?.editedMessage?._id);
          // }),
          data: [...(filteredChatRoomMessages || [])],
          // chatId: filteredChatRoomMessages?.[0]?.chatId || state?.chatRoomMessages?.chatId,
          isLoading: false,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            chatRoomsArrCpy?.map((chatRoom) => {
              return chatRoom?._id === state?.selectedChatRoom?.data?._id;
            }) || state?.selectedChatRoom?.data,
        },
      };
    }

    case ON_DELETE_MESSAGE_GROUP_CHAT: {
      let chatRoomsArrCpy = [...state.chatRooms.data];
      let filteredChatRoomMessages = [];

      if (
        action?.payload?.deletedMessage?.chatId !==
        (state?.chatRoomMessages?.data?.[0]?.chatId ||
          state?.chatRoomMessages?.chatId)
      ) {
        filteredChatRoomMessages = [...(state?.chatRoomMessages?.data || [])];
      } else {
        filteredChatRoomMessages = state?.chatRoomMessages?.data?.filter(
          (chatRoomMessage) => {
            return (
              chatRoomMessage?._id !== action?.payload?.deletedMessage?._id
            );
          },
        );
      }

      const deletedMessageChatRoomIdx = chatRoomsArrCpy?.findIndex(
        (chatRoom) => {
          return chatRoom?._id === action?.payload?.deletedMessage?.chatId;
        },
      );

      const sortedChatRoomMessages = [
        ...(filteredChatRoomMessages || []),
      ]?.sort((a, b) => {
        const aDate = new Date(a.timestamp);
        const bDate = new Date(b.timestamp);
        if (aDate < bDate) {
          return -1;
        }
        if (aDate > bDate) {
          return 1;
        }
        return 0;
      });

      if (deletedMessageChatRoomIdx >= 0) {
        chatRoomsArrCpy = chatRoomsArrCpy?.map((chatRoom, chatRoomIdx) => {
          if (chatRoomIdx === deletedMessageChatRoomIdx) {
            return {
              ...chatRoom,
              latestMessage:
                sortedChatRoomMessages?.[sortedChatRoomMessages?.length - 1],
            };
          } else {
            return chatRoom;
          }
        });
      }

      return {
        ...state,
        chatRooms: {
          ...state?.chatRooms,
          data: chatRoomsArrCpy,
        },
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          // data: action?.payload?.deletedMessage?.chatId !== state?.chatRoomMessages?.data?.[0]?.chatId ? (
          //   [...(state?.chatRoomMessages?.data || [])]
          // ) : state?.chatRoomMessages?.data?.filter(chatRoomMessage => {
          //   return (chatRoomMessage?._id !== action?.payload?.deletedMessage?._id);
          // }),
          data: [...(filteredChatRoomMessages || [])],
          // chatId: filteredChatRoomMessages?.[0]?.chatId || state?.chatRoomMessages?.chatId,
          isLoading: false,
        },
        selectedChatRoom: {
          ...state?.selectedChatRoom,
          data:
            chatRoomsArrCpy?.find((chatRoom) => {
              return chatRoom?._id === state?.selectedChatRoom?.data?._id;
            }) || state?.selectedChatRoom?.data,
        },
      };
    }

    case UPDATE_POST_COLLAPSE_MESSAGES: {
      const updatedChatRoomMessages = state?.chatRoomMessages?.data?.map?.(
        (post) => {
          if (post.postMetaData?.postId === action?.payload?.postId) {
            return {
              ...post,
              postMetaData: {
                ...post?.postMetaData,
                collapsedMessages:
                  action?.payload?.collapsedMessages ||
                  !post?.postMetaData?.collapsedMessages,
              },
            };
          } else {
            return post;
          }
        },
      );

      return {
        ...state,
        chatRoomMessages: {
          ...state?.chatRoomMessages,
          data: updatedChatRoomMessages,
        },
      };
    }

    case ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT:
      return {
        ...state,
        chatRoomMessages: {
          ...initialState.chatRoomMessages,
          chatId: action?.payload?.chatRoom?._id,
        },
        newMessage: {
          ...initialState.newMessage,
        },
        selectedChatRoom: {
          ...state.selectedChatRoom,
          data: action?.payload?.chatRoom,
        },
      };

    case RESET_GROUP_CHAT_SLICE: {
      return {
        ...state,
        selectedChatRoom: {
          ...initialState.selectedChatRoom,
        },
        chatRoomMessages: {
          ...initialState.chatRoomMessages,
        },
      };
    }

    case GET_UNREAD_MESSAGES_REQUEST:
      return {
        ...state,
        unreadMessages: {
          ...state?.unreadMessages,
          isLoading: true,
        },
      };

    case GET_UNREAD_MESSAGES_FAILURE:
      return {
        ...state,
        unreadMessages: {
          ...state?.unreadMessages,
          isLoading: false,
        },
      };

    case GET_UNREAD_MESSAGES_SUCCESS: {
      return {
        ...state,
        unreadMessages: {
          data: action?.payload?.data,
          isLoading: false,
        },
      };
    }

    // message information
    case GET_MESSAGE_PARTICIPANT_STATUS_REQUEST:
      return {
        ...state,
        messageDetails: {
          ...state?.messageDetails,
          isLoading: true,
        },
      };

    case GET_MESSAGE_PARTICIPANT_STATUS_FAILURE:
      return {
        ...state,
        messageDetails: {
          ...state?.messageDetails,
          isLoading: false,
        },
      };

    case GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS:
      return {
        ...state,
        messageDetails: {
          data: action?.payload?.data,
          isLoading: false,
        },
      };

    default:
      return state;
  }
};

export default groupMessagingReducer;
export { initialState };